import React, {useContext, useEffect, useLayoutEffect, useState} from "react";

import MobileHeader from "../components/mobile/MobileHeader";
import BottomNav from "../components/mobile/BottomNav";
import {AppContext} from "../App";
import {useHistory} from "react-router-dom";
import {AppService} from "../services/app.service";
import {BASE_URL} from "../env.json";

import Answer from "../components/v2/steps/answer";
import QuizMultipleChoice from "../components/v2/steps/quizMultipleChoice";
import MultiTextInput from "../components/steps/quizzes/MultiTextInput";
import QuizEssay from "../components/v2/steps/quizEssay";
import SurveyType from "../components/steps/quizzes/SurveyType";
import MultipleCheck from "../components/steps/quizzes/MultipleCheck";
import PersonAdmire from "../components/steps/quizzes/PersonAdmire";
import {Fade, IconButton, Snackbar} from "@material-ui/core";
import TopNavBar from "../components/TopNavBar";
import CloseIcon from "@material-ui/icons/Close";
import Transcript from "../components/steps/Transcript";
import Audible from "../components/steps/Audible";
import MultipleChoice from "../components/steps/quizzes/MultipleChoice";
import AnswerReveal from "../components/steps/quizzes/AnswerReveal";
import PhaseMessage from "../components/PhaseMessage";
import ReflectiveWriting from "../components/steps/quizzes/ReflectiveWriting";
import SideNav from "../components/SideNav";

function TasksView() {
    // Note:
    // Task and Step is zero based.
    // Order number is always + 1 to array address
    // Week is exempted because ordering follows the indices

    const context = useContext(AppContext);
    const content = context.appContent;

    // console.log("Week = ", context.currentWeekNo, "Task = ", context.currentTaskNo, "Step = ", context.currentStepNo);
    const contentCount = Number(content?.length)
    const currentWeekNo = Number(context.currentWeekNo);
    const currentTaskNo = Number(context.currentTaskNo);
    const currentStepNo = Number(context.currentStepNo);
    const currentLessonNo = Number(context.currentLessonNo);

    const totalNumberOfWeeks = contentCount - 1;

    const currentWeek = content?.[currentWeekNo];
    const tasks = currentWeek.tasks;
    const steps = tasks[currentTaskNo].steps;
    const current_step = steps[currentStepNo];

    const [userWeekNo, setUserWeekNo] = useState<number>(0);
    const [userTaskNo, setUserTaskNo] = useState<number>(0);
    const [userLessonNo, setUserLessonNo] = useState<number>(0);

    const [weekProgressPercentage, setWeekProgressPercentage] = useState<number>(0)

    let history = useHistory();

    //PacingMessage
    const [pacingMessageIsOpen, togglePacingMessage] = useState<boolean>(false);
    const [pcmGreeting, setPCMGreeting] = useState<string>("");
    const [pcmHeading, setPCMHeading] = useState<string>("");
    const [pcmDetails, setPCMDetails] = useState<string>("");
    const [pcmPrimaryActionLabel, setPcmPrimaryActionLabel] = useState<string>("");
    const [pcmSecondaryActionLabel, setPcmSecondaryActionLabel] = useState<string>("");
    const [pcmEndOfWeek, toggleEndOfWeek] = useState<boolean>(false)

    function clearPCM(){
        togglePacingMessage(false);
        setPCMGreeting("");
        setPCMDetails("");
        setPCMHeading("");
        toggleEndOfWeek(false);
    }

    function openPCM(greet: string,
                     heading: string,
                     details: string,
                     actionLabel: string,
                     secActionLabel:string,
                     isEndOfWeek: boolean = false) {
        togglePacingMessage(true);
        setPCMGreeting(greet);
        setPCMHeading(heading);
        setPCMDetails(details);
        setPcmPrimaryActionLabel(actionLabel);
        setPcmSecondaryActionLabel(secActionLabel);
        toggleEndOfWeek(isEndOfWeek)
    }


    // for snack bar
    const [open, setOpen] = useState<boolean>(false)
    const [alertMsg, setAlertMsg] = useState<string>("")

    function moveNext() {
        let step = currentStepNo;
        step++;

        // check if end of steps
        if(step > (steps.length - 1)){
            let incrementedTask = currentTaskNo;
            //try increment
            incrementedTask++;

            //checks if the incremented task is greater than content's Task
            if(incrementedTask > (tasks.length - 1)) {
                if(incrementedTask > (userTaskNo-1) && currentWeekNo <= totalNumberOfWeeks) {
                    advanceTask(tasks[currentTaskNo].id)
                    //history.push(`/weeks/${context.deviceId}/${context.recoveryId}`);
                    openPCM('GOOD WORK!',
                        `You've completed Week ${currentWeekNo}!`,
                        `Good work on your recovery!`,
                        `Great!`, '', true);
                }

                if (incrementedTask > (userTaskNo-1) && currentWeekNo >= totalNumberOfWeeks) {
                    openPCM('CONGRATULATIONS!',
                        `You've completed Ascend!`,
                        `Celebrating wins helps create more wins! James Clear, the author of Atomic Habits, says, 
                        "Pleasure and satisfaction are what sustain a behavior... 
                        Feeling successful gets you to repeat." What helpful steps from Ascend would you consider 
                        repeating throughout your life?`,
                        `Great!`, '', true);
                    endProgram(tasks[currentTaskNo].id);
                }
            }
            else {
                // had had to subtract 1 to match array index to order number
                if(incrementedTask > (userTaskNo-1) && currentWeekNo >= userWeekNo) {
                    advanceTask(tasks[currentTaskNo].id)
                }
                context.setCurrentTaskNo(incrementedTask);
                context.setCurrentStepNo(0);
                context.setCurrentLessonNo(tasks[incrementedTask].lesson_no)
            }
        }
        else {
            context.setCurrentStepNo(step);
        }

    }

    function moveBack() {
        if(currentStepNo <= 0) {
            history.goBack();
        } else {
            let step: number = currentStepNo;
            step--;
            context.setCurrentStepNo(step);
        }
    }

    async function advanceTask(taskId: string) {
        try{
            const appService = new AppService();
            const newTasks = await appService.advanceTask(BASE_URL + `recovery2/advance-task/`, taskId);
            console.log(`NEW TASK`,newTasks)
        }
        catch (Error) {
            setAlertMsg('Unable to Save progress. Please check your internet.')
            setOpen(true)
        }
    }

    async function endProgram(taskId: string) {
        try{
            const appService = new AppService();
            const newTasks = await appService.advanceTask(BASE_URL + `recovery2/complete-program/`, taskId);
            console.log(newTasks)
        }
        catch (Error) {
            setAlertMsg('Unable to Save progress. Please check your internet.')
            setOpen(true)
        }
    }

    useLayoutEffect(()=>{
        console.log("GETTING DATA FROM TASKVIEW")
        async function getUserData(){
            let appService = new AppService();
            const userData = await appService.fetchData(BASE_URL + `recovery2/recovery2-user/${context.recoveryId}/`);
            //console.log('User Data ==> ', userData);
            if(userData !== undefined) {
                setUserWeekNo(Number(userData.data.current_task.week.ordering_number));
                setUserTaskNo(Number(userData.data.current_task.ordering_number));
                setUserLessonNo(Number(userData.data.current_task.lesson));
            }
        }
        getUserData();
    }, [context])

    useEffect(()=>{
        // console.log("USE EFFECT")
        const appService = new AppService();
        async function getProgress(){

            const userData = await appService.fetchData(BASE_URL + `recovery2/recovery2-user/${context.recoveryId}/`);
            // console.log('USERDDATA == ' , userData)
            try {

                // get the users week and task'
                let userWeekNo: number = Number(userData.data.current_task.week.ordering_number);
                let userTaskNo: number = Number(userData.data.current_task.ordering_number) - 1;

                // compute base on client state
                if(userWeekNo > Number(context.currentWeekNo)){
                    setWeekProgressPercentage(100);
                } else  {

                    let totalActiveTaskCount = context.activeWeekTaskList.tasks.length;
                    let percentage = (userTaskNo/totalActiveTaskCount) * 100;
                    setWeekProgressPercentage(percentage);
                }
            }
            catch (Error) {
                console.log(Error.message)
            }
        }
        getProgress();
    });

    let stepComponent: any;

    if(current_step.type === 'transcript') {
        stepComponent = <Transcript
            id={current_step.data.id}
            weekNo={currentWeekNo}
            taskNo={currentTaskNo}
            header={tasks[currentTaskNo].title}
            transcript={current_step.data.transcript}
            buttonLabel={current_step.data.next_button_label}
            moveBack={moveBack}
            moveNext={moveNext}/>
    }

    if(current_step.type === 'answer') {
        stepComponent = <AnswerReveal
            id={current_step.data.id}
            weekNo={currentWeekNo}
            taskNo={currentTaskNo}
            header={tasks[currentTaskNo].title}
            answer={current_step.data.correct_answer}
            transcript={current_step.data.explanatory}
            buttonLabel={current_step.data.next_button_label}
            moveBack={moveBack}
            moveNext={moveNext}/>
    }

    if(current_step.type === 'audible') {
        let audioTranscript = current_step.data.transcript;
        stepComponent = <Audible
            id={current_step.data.id}
            weekNo={currentWeekNo}
            taskNo={currentTaskNo}
            header={currentWeek.title}
            audioUrl={current_step.data.audio_url}
            transcript={audioTranscript}
            buttonLabel={current_step.data.next_button_label}
            moveBack={moveBack}
            moveNext={moveNext}/>
    }

    if(current_step.type === 'question'){
        let questionType = current_step.data.question_type;
        let questionConfig = JSON.parse(current_step.data.question_configuration);
        if(questionType === 'multiple_choice') {
            stepComponent = <MultipleChoice
                id={current_step.data.id}
                questionConfig={questionConfig}
                weekNo={currentWeekNo}
                taskNo={currentTaskNo}
                prompt={current_step.data.prompt}
                buttonLabel={current_step.data.next_button_label}
                moveBack={moveBack}
                moveNext={moveNext}/>
        }

        if(questionType === 'multi_input') {
            stepComponent = <MultiTextInput
                id={current_step.data.id}
                questionConfig={questionConfig}
                weekNo={currentWeekNo}
                taskNo={currentTaskNo}
                prompt={current_step.data.prompt}
                buttonLabel={current_step.data.next_button_label}
                moveBack={moveBack}
                moveNext={moveNext}/>
        }

        if(questionType === 'essay'){
            stepComponent = <ReflectiveWriting
                id={current_step.data.id}
                questionConfig={questionConfig}
                weekNo={currentWeekNo}
                taskNo={currentTaskNo}
                question={current_step.data.prompt}
                buttonLabel={current_step.data.next_button_label}
                moveBack={moveBack}
                moveNext={moveNext}
                header={tasks[currentTaskNo].title}/>
        }

        if(questionType === 'survey'){
            stepComponent = <SurveyType
                id={current_step.data.id}
                questionConfig={questionConfig}
                weekNo={currentWeekNo}
                taskNo={currentTaskNo}
                prompt={current_step.data.prompt}
                buttonLabel={current_step.data.next_button_label}
                moveBack={moveBack}
                moveNext={moveNext} />
        }

        if(questionType === 'multi_selection') {
            stepComponent = <MultipleCheck
                id={current_step.data.id}
                questionConfig={questionConfig}
                weekNo={currentWeekNo}
                taskNo={currentTaskNo}
                prompt={current_step.data.prompt}
                buttonLabel={current_step.data.next_button_label}
                moveBack={moveBack}
                moveNext={moveNext} />
        }

        if(questionType === 'person_admire') {
            stepComponent = <PersonAdmire
                id={current_step.data.id}
                questionConfig={questionConfig}
                weekNo={currentWeekNo}
                taskNo={currentTaskNo}
                prompt={current_step.data.prompt}
                buttonLabel={current_step.data.next_button_label}
                moveBack={moveBack}
                moveNext={moveNext} />
        }


    }

    const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    useEffect(()=> {
        if ((currentLessonNo > userLessonNo) &&
            (currentLessonNo > 0) &&
            (userWeekNo <= currentWeekNo) &&
            (userLessonNo > 0)) {
            openPCM('GOOD WORK!',
                `You've completed the tasks for Lesson ${currentLessonNo - 1} of Week ${currentWeekNo}`,
                `Nicely done!`,
                `Start Lesson ${currentLessonNo}`, `No thanks, I'm done for now`);
        }
        else {
            //console.log("No progress yet.");
        }
    },[currentWeekNo,context.currentLessonNo, userWeekNo, userLessonNo, currentLessonNo]);


    return (
        <div className={'container'}>
            <SideNav/>
            <div className={'app-page'}>
                <div className={'task-view'}>
                    {(pacingMessageIsOpen) ?
                        (<Fade in={pacingMessageIsOpen} timeout={2000}>
                            <PhaseMessage greeting={pcmGreeting}
                                           msgHeading={pcmHeading}
                                           msgDetails={pcmDetails}
                                           primaryButton={pcmPrimaryActionLabel}
                                           primaryButtonAction={()=>{
                                               clearPCM();
                                               if(pcmEndOfWeek) {
                                                   history.push(`/home/${context.deviceId}/${context.recoveryId}`);
                                               }
                                           }}
                                           secondaryButton={pcmSecondaryActionLabel}
                                           secondaryButtonAction={()=>{
                                               history.push(`/home/${context.deviceId}/${context.recoveryId}`);
                                           }}/>
                        </Fade>)
                        :
                        (<div>
                            <TopNavBar weekNo={currentWeekNo} lessonNo={context.currentLessonNo} progress={weekProgressPercentage}/>
                            <div className={'component-container'}>
                                {stepComponent}
                            </div>
                            <Snackbar
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                open={open}
                                autoHideDuration={6000}
                                onClose={handleClose}
                                message={alertMsg}
                                action={
                                    <React.Fragment>
                                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </React.Fragment>
                                }
                            />
                        </div> )
                    }
                </div>
            </div>
        </div>
    )
}

export default TasksView;
